module.exports = __webpack_public_path__ + "static/media/section_2_img.fd0d201a.png";